Ext.define('SA.lq.view.ExportDocMouseHandler', {
    constructor({isInMenu, isInToolbarExportBtn, beyondLimitPopupPresent}) {
        this.isInMenu = isInMenu;
        this.isInToolbarExportBtn = isInToolbarExportBtn;
        this.beyondLimitPopupPresent = beyondLimitPopupPresent;
    },

    onClick(ev) {
        if (this.beyondLimitPopupPresent || this.isInMenu(ev)) {
            return;
        }

        if (this.isInToolbarExportBtn(ev)) {
            ev.stopPropagation(); 
        }

        this.outsideMenuClickCb();
    },

    onMousedown(ev) {
        if (this.isInMenu(ev)) {
            return;
        }

        ev.stopPropagation(); 
    },

    setBeyondLimitPopupPresent(beyondLimitPopupPresent) {
        this.beyondLimitPopupPresent = beyondLimitPopupPresent;
    },

    setOutsideMenuClickCb(outsideMenuClickCb) {
        this.outsideMenuClickCb = outsideMenuClickCb;
    }
});